import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantUnemploymentTypePage = {
  alert: {
    error: 'applicant-unemployment-type-page.form.alert.error',
  },
  footer: {
    root: 'applicant-unemployment-type-page.footer.root',
  },
  form: {
    h1: 'applicant-unemployment-type-page.form.h1',
    h2: 'applicant-unemployment-type-page.form.h2',
    radioGroupRoot: 'applicant-unemployment-type-page.form.radio-group-root',
    radioOption1: 'applicant-unemployment-type-page.form.radio-option1',
    radioOption2: 'applicant-unemployment-type-page.form.radio-option2',
    radioOption3: 'applicant-unemployment-type-page.form.radio-option3',
    radioOption4: 'applicant-unemployment-type-page.form.radio-option4',
    radioOption5: 'applicant-unemployment-type-page.form.radio-option5',
    root: 'applicant-unemployment-type-page.form.root',
    submitButton: 'applicant-unemployment-type-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
